import { Cog } from "lucide-react";
import { UserAvatar } from "@/components/ui/user-avatar";
import { cn } from "@/lib/utils";
import type { UserProfile } from "@/domains/pm/types";

interface ActorAvatarProps {
  /** The user who performed the activity, or null for a system /
   *  service-role action (no user). */
  actor: UserProfile | null | undefined;
  size?: number;
  className?: string;
}

/**
 * Avatar for an activity row's actor. A real user renders via UserAvatar —
 * which already shows the saved colour + initials when they have no profile
 * picture, identical to the /issues page. The muted system glyph is used ONLY
 * when there is no user at all (activity authored by a service-role writer).
 */
export function ActorAvatar({ actor, size = 24, className }: ActorAvatarProps) {
  if (actor) {
    return <UserAvatar user={actor} size={size} className={className} />;
  }
  return (
    <span
      className={cn(
        "inline-flex flex-shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground",
        className
      )}
      style={{ width: size, height: size }}
      aria-label="System"
      title="System"
    >
      <Cog style={{ width: size * 0.55, height: size * 0.55 }} />
    </span>
  );
}
